import { render, staticRenderFns } from "./BusinessApplicationPriceApplyList.vue?vue&type=template&id=6a3fd95a"
import script from "./BusinessApplicationPriceApplyList.vue?vue&type=script&lang=js"
export * from "./BusinessApplicationPriceApplyList.vue?vue&type=script&lang=js"
import style0 from "./BusinessApplicationPriceApplyList.vue?vue&type=style&index=0&id=6a3fd95a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports